import { Component, OnInit } from '@angular/core';
import { RecaptchaErrorParameters } from "ng-recaptcha"
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { PartnersTunaService } from '../../contexts/partners/partners-tuna.service';
import { CpfCnpjValidator } from '../../core/utils/cpf-cnpj.validator';
import { Title } from '@angular/platform-browser';
import { CustomIconService } from 'src/app/core/services/custom-icon.service';
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-register-partner',
  templateUrl: './register-partner.component.html',
  styleUrls: ['./register-partner.component.scss']
})
export class RegisterPartnerComponent implements OnInit {

  companyName: string = "";
  username: string = "";
  form: FormGroup;
  confirm = false;
  recaptchaInvalid = true;
  countrySelected = 'br';
  pageVersion: string;
  countryOptions = [
    { value: "br", viewValue: "+55", icon: "brasil" },
    { value: "usa", viewValue: "+1", icon: "united-states-of-america" }
  ];

  constructor(private fb: FormBuilder,
    private partnerService: PartnersTunaService,
    private translateService: TranslateService,
    private toastr: ToastrService,
    private customIconService: CustomIconService,
    private titleService: Title,
    public route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.translateService.use("pt-br");

    this.customIconService.init();
    this.titleService.setTitle('Cadastro • Tuna');

    this.route.url.subscribe(params => {
      this.pageVersion = params[0].path;
    })

    this.form = this.fb.group({
      partner_name: ['', ''],
      partner_key: [''],
      partner_document: [''],
      email: [''],
      first_name: ['', ''],
      last_name: ['', ''],
      recaptchaReactive: ['', ''],
      phone: ['', '']
    });

    this.form.get('partner_key').disable();
  }

  companyNameChange(str) {
    var partner_name = this.form.get('partner_name').value;
    this.form.get('partner_key').setValue(this.stringToSlug(partner_name));
  }

  stringToSlug(str) {
    str = str.replace(/^\s+|\s+$/g, "");
    str = str.toLowerCase();

    // remove accents
    var from = "àáäâãèéëêìíïîòóöôõùúüûñç·/_,:;";
    var to = "aaaaaeeeeiiiiooooouuuunc------";
    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }

    str = str
      .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
      .replace(/\s+/g, "-") // collapse whitespace and replace by -
      .replace(/-+/g, "-"); // collapse dashes

    return str.slice(0, 30);
  }

  public resolved(captchaResponse: string): void {
    if (captchaResponse)
      this.recaptchaInvalid = false;
    else
      this.recaptchaInvalid = true;
    // console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  public onError(errorDetails: RecaptchaErrorParameters): void {
    this.recaptchaInvalid = true;
  }

  clearValidator(value) {
    this.form.get(value).clearValidators();
    this.form.get(value).updateValueAndValidity();
  }

  submit(value: any) {

    console.log('save partner');

    this.inputFormValidation();

    if (this.form.valid) {
      let country = this.countryOptions.find(p => p.value == this.countrySelected);
      var partner = {
        partner_name: this.form.get('partner_name').value,
        partner_key: this.form.get('partner_key').value,
        partner_document: this.form.get('partner_document').value,
        email_owner: this.form.get('email').value,
        first_name_owner: this.form.get('first_name').value,
        last_name_owner: this.form.get('last_name').value,
        account_name: this.form.get('partner_name').value,
        account_key: this.form.get('partner_key').value,
        locale: 'pt-BR',
        phone: this.form.get('phone').value ? (country.viewValue + this.form.get('phone').value) : "",
        register_url: window.location.href
      }
      var self = this;

      this.partnerService.validate(null, null, partner)
        .subscribe({
          next: (response) => {

            if (response) {
              this.partnerService.register(null, null, partner).subscribe(
                {
                  next: async (response) => {
                    if (response) {
                      self.toastr.success(self.translateService.instant('partners.actions.success'));
                      self.confirm = !self.confirm;
                    }
                  },
                  error(error) {
                    console.log("error");
                    if (error.result)
                      if (error.result.length > 0) {
                        error.result.forEach(element => {

                          if (element.property == 'SRVPartnerKeyAlreadyExists') {
                            self.form.get('partner_key').enable();
                          }

                          self.toastr.error(element.message);
                        });
                      }


                  }
                }

              );
            }
          },
          error(error) {
            console.log("error");
            if (error.result)
              if (error.result.length > 0) {
                error.result.forEach(element => {
                  console.log(element.message);
                  self.toastr.error(element.message);
                });
              }
          }
        });

    } else {
      this.validateAllFormFields(this.form);
    }

  }

  inputFormValidation() {
    this.form.get('partner_name').setValidators([Validators.required]);
    this.form.get('partner_name').updateValueAndValidity();
    this.form.get('partner_key').setValidators([Validators.required]);
    this.form.get('partner_key').updateValueAndValidity();
    this.form.get('partner_document').setValidators([Validators.required, CpfCnpjValidator.validate, , Validators.pattern('[0-9]*')]);
    this.form.get('partner_document').updateValueAndValidity();
    this.form.get('first_name').setValidators([Validators.required]);
    this.form.get('first_name').updateValueAndValidity();
    this.form.get('last_name').setValidators([Validators.required]);
    this.form.get('last_name').updateValueAndValidity();
    this.form.get('email').setValidators([Validators.required, Validators.email]);
    this.form.get('email').updateValueAndValidity();
    this.form.get('recaptchaReactive').setValidators([Validators.required]);
    this.form.get('recaptchaReactive').updateValueAndValidity();
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

}
